// extracted by mini-css-extract-plugin
export default {"newsSection":"index-module--newsSection--60c6b","content":"index-module--content--599e8"};